<template>
	<div class="id">
		<img class="bgImg" src="/img/imgBg1.jpg" />
		<div class="login">
			<van-nav-bar class="nav-bars">
				<template #right>
					<div class="language" @click="$router.push('/language')">
						<!-- <img src="/img/dq.png" /> -->
						<van-icon name="setting" color="#7c5dd4" size="26" style="padding-top: 10px;" />
					</div>
				</template>
			</van-nav-bar>
			<div class="wrapper">
				<img src="/img/logo.png" class="imgBox" v-if="logo" />
				<div v-else class="imgBox"></div>
				<div class="title">{{$t("auth.title")}}</div>
				<div class="loginForm">
					<van-field v-model="username" clearable input-align="center" class="input"
						:placeholder="$t('auth.username_place')" />
					<van-field v-model="password" :type="passwordType" input-align="center" class="input"
						:placeholder="$t('auth.pwd_place')">
						<template slot="right-icon">
							<van-icon :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
								@click="switchPasswordType" />
						</template>
					</van-field>
					<div class="reset-text">
						<span>{{$t("auth.forgetpwd")}}?</span>
					</div>
					<div @click="toRegister()" class="register-text">
						<span>{{$t("auth.no_account")}}</span>
					</div>
					<van-button class="login-btn" type="primary" size="normal"
						@click="doLogin()">{{$t("auth.login")}}</van-button>
					<van-button class="login-btn" type="primary" size="normal"
						@click="doLogin(true)">{{$t("textS")}}</van-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		model: {
			prop: "inputValue",
			event: "input",
		},
		props: {
			/**
			 * 当前输入的值
			 */
			inputValue: {
				type: String,
				default: "",
			},
		},
		data() {
			return {
				username: "",
				iconS: '../images/dp.png',
				password: this.inputValue,
				passwordType: "password",
				logo: ''
			};
		},
		mounted() {
			this.getBaseInfo()

		},
		methods: {
			getBaseInfo() {
				this.$http({
					method: 'get',
					url: 'base_info'
				}).then(res => {
					this.logo = res.data.logo
				})
			},
			switchPasswordType() {
				this.passwordType =
					this.passwordType === "password" ? "text" : "password";
			},
			back() {
				return window.history.back();
			},
			toRegister() {
				this.$router.push("Register");
			},
			doLogin(tourists = false) {
				this.$http({
					url: "login",
					method: "post",
					data: {
						username: tourists ? 'Guest' : this.username,
						password: tourists ? '123123' : this.password,
					},
				}).then((res) => {
					if (res.code == 1) {
						console.log(res.data.userinfo.token)
						localStorage.setItem('token', res.data.userinfo.token)
						this.$router.push("Mine");
					} else {
						this.$toast(res.msg);
					}
				});
			},

		},
		created() {
			if (localStorage.getItem("token")) {
				return window.history.back();
			}
		},
	};
</script>

<style lang='less' scoped>
	::v-deep .van-icon {
		font-size: 50px;
	}

	.nav-bars {
		background-color: rgba(255, 255, 255, 0) !important;
	}

	.id {
		position: relative;
		min-height: 100vh;

		.bgImg {
			position: absolute;
			top: 0;
			right: 0;
			object-fit: cover;
			height: 100%;
			width: 100%;
		}

		.login {
			width: 100%;
			min-height: 100vh;
			background: linear-gradient(hsla(0, 0%, 100%, 0), #f905e5);
			position: absolute;
			top: 0;
			right: 0;
			z-index: 1;

			.language {
				position: absolute;
				top: 10px;
				right: 40px;
				height: 62px;

				img {
					margin-top: 20px;
					width: 50px;
					height: 50px;
				}

			}

			.wrapper {
				.imgBox {
					margin-top: 20px;
					width: 200px;
					height: 200px;
					margin: 0 auto;
					display: block;
				}

				.title {
					line-height: 100px;
					text-align: center;
					font-size: 45px;
					font-weight: 700;
					color: #fff;
					letter-spacing: 5px;
				}

				.loginForm {
					padding: 60px;

					.input {
						padding: 10px 20px;
						margin-top: 40px;
						border-radius: 50px;
						text-align: center;
						line-height: 80px;
						font-size: 30px;
						color: #4e4e4e;
					}

					.reset-text {
						margin: 50px 15px;
						display: flex;
						align-items: center;
						justify-content: flex-end;
					}

					.reset-text span {
						color: #fff;
						font-size: 25px;
						font-weight: 500;
						line-height: 15px;
					}

					.register-text {
						margin: 20px 0;
						display: flex;
						align-items: center;
						justify-content: center;
					}

					.register-text span {
						color: #fff;
						font-size: 25px;
						font-weight: 500;
						line-height: 20px;
					}

					.login-btn {
						margin-top: 85px;
						width: 100%;
						height: 100px;
						border-radius: 50px;
						color: #fff;
						background: linear-gradient(90deg, #c24491, #775fd9);
						font-size: 30px;
						font-weight: bolder;
						border: none;
					}
				}
			}
		}
	}
</style>